module.exports = __webpack_public_path__ + "static/vr-5-2-a871c02e9ed7ceeb14729b0272296f34.jpeg";